import ConciergeBellIcon from "@mui/icons-material/RoomService";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useConciergeMode } from "@/contexts/ConciergeModeContext";

export const ConciergeModeBanner = () => {
  const { t } = useTranslation();
  const { isConciergeMode, setConciergeMode } = useConciergeMode();

  if (!isConciergeMode) return null;

  return (
    <Alert
      icon={<ConciergeBellIcon fontSize="small" />}
      severity="info"
      sx={(theme) => ({
        borderRadius: 0,
        flexShrink: 0,
        alignItems: "center",
        color: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.primary[700]}`,
        background: `linear-gradient(90deg, ${theme.palette.primary[700]} 0%, ${theme.palette.secondary[700]} 100%)`,
        "& .MuiAlert-message": {
          flexGrow: 1,
          width: "100%",
          padding: 0,
        },
        "& .MuiAlert-icon": {
          color: theme.palette.common.white,
          marginRight: theme.spacing(1),
          alignSelf: "center",
        },
      })}
      action={
        <Button
          variant="outlined"
          size="small"
          onClick={() => setConciergeMode(false)}
          sx={(theme) => ({
            color: theme.palette.common.white,
            borderColor: theme.palette.common.white,
            "&:hover": {
              borderColor: theme.palette.common.white,
              backgroundColor: "rgba(255, 255, 255, 0.12)",
            },
          })}
        >
          {t("conciergeMode.banner.exit")}
        </Button>
      }
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        gap={0.5}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          {t("conciergeMode.banner.title")}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.95 }}>
          {t("conciergeMode.banner.description")}
        </Typography>
      </Stack>
    </Alert>
  );
};
